/*
* @描述: 订单售后详情
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025/3/18 09:57
*/
<template>
    <el-form :label-position="label_position"
             class="custom_detail_form"
             size="small">
        <div v-if="Object.keys(business_data).length">
            <h3 class="approve_title_h3" v-text="afterSaleTypeName"></h3>
            <el-form-item label="关联订单">
                    <span class="link-label" @click="handleClickOrderDetail"
                          v-text="business_data.order.order_num"></span>
            </el-form-item>
            <el-form-item label="关联客户">
                    <span class="link-label" @click="handleClickCustomerDetail"
                          v-text="business_data.customer.name"></span>
            </el-form-item>
            <el-form-item label="订单负责人">
                <div class="custom_contact_field_wrap">
                    <PersonnelCard v-if="business_data.salesperson && business_data.salesperson.id"
                                   :userId="business_data.salesperson.id">
                        <template slot="container">
                            <img :src="business_data.salesperson.avatar" alt=""
                                 class="avatar">
                            <span class="name" v-text="business_data.salesperson.name"></span>
                        </template>
                    </PersonnelCard>
                </div>
            </el-form-item>
            <h3 class="approve_title_h3">售后内容</h3>
        </div>
        <!--订单编辑详情-->
        <template v-if="after_sales_type === 'order_edit'">
            <template v-for="item in form_detail">
                <el-form-item v-if="item.field_type==='goods'">
                    <h4 class="mb_12">产品信息</h4>
                    <ul class="m_detail_order_goods_list">
                        <li v-for="row in item.value" :key="row.order_goods_id"
                            class="order_goods_item">
                            <div v-if="row.type===2" class="lease_time">
                                <span>租借起止时间：</span>
                                <span v-text="row.diff_start_at&&row.diff_start_at.is_diff?row.diff_start_at.new:row.start_at"></span>
                                <span>~</span>
                                <span v-text="row.diff_end_at&&row.diff_end_at.is_diff?row.diff_end_at.new:row.end_at"></span>
                                <span v-if="(row.diff_start_at&&row.diff_start_at.is_diff)||(row.diff_end_at&&row.diff_end_at.is_diff)"
                                      class="handle_icon_wrap handle_icon_warning_wrap"
                                      @click="handleClickShowGoodsDiff('lease_time',row)">
                                    <i class="iconfont icon-shuoming"></i>
                                </span>
                            </div>
                            <div class="table_goods_info_wrap goods_info_wrap">
                                <div v-if="row.action" :class="'good_icon_'+row.action"
                                     class="good_icon_img_wrap">
                                    <img v-if="row.action==='edit'"
                                         alt=""
                                         src="https://download.hecoos.com/enlightv/2025-07/45966fcae0aaec12c78e3fff15870ac5.png">
                                    <img v-else-if="row.action==='add'"
                                         alt=""
                                         src="https://download.hecoos.com/enlightv/2025-07/8393bdb0e456568e5bc70829d42e2fc8.png">
                                    <img v-else-if="row.action==='del'"
                                         alt=""
                                         src="https://download.hecoos.com/enlightv/2025-07/531f541fb008544c0fb8b9eb80310a72.png">
                                </div>
                                <div class="goods_image_wrap">
                                    <img :src="row.goods_image?row.goods_image:'https://download.hecoos.com/enlightv/2025-03/9d94ed737997e3e1e393bb74609ffc64.jpg'"
                                         alt="">
                                    <div v-if="row.goods_status===0||row.goods_deleted_at"
                                         class="good_status_text"
                                         v-text="row.goods_status===0?'':row.goods_deleted_at?'已删除':''"></div>
                                </div>
                                <div class="goods_name_wrap">
                                    <div :class="{'del_text':row.action==='del'}" class="goods_name">
                                        <span v-text="row.goods_name"></span>
                                        <span v-if="row.goods_sku_name&&row.goods_type!=='bundle'"
                                              v-text="'：'+row.goods_sku_name"></span>
                                        <el-tag :class="{'del_text':row.action==='del'}"
                                                :type="row.type===1?'success':'warning'"
                                                size="mini">
                                            {{ row.type === 1 ? '销售' : '租借' }}
                                        </el-tag>
                                    </div>
                                    <div class="flex_js_wrap">
                                        <div :class="{'del_text':row.action==='del'}"
                                             class="goods_price flex_wrap">
                                            <span v-text="row.price&&row.price.text?'¥'+row.price.text:'--'"></span>
                                            <span v-if="row.diff_price&&row.diff_price.is_diff"
                                                  class="handle_icon_wrap handle_icon_warning_wrap"
                                                  @click="handleClickShowGoodsDiff('price',row)">
                                                <i class="iconfont icon-shuoming"></i>
                                            </span>
                                        </div>
                                        <div :class="{'del_text':row.action==='del'}" class="flex_wrap">
                                            <span class="goods_num" v-text="'X' + row.num"></span>
                                            <span v-if="row.diff_num&&row.diff_num.is_diff"
                                                  class="handle_icon_wrap handle_icon_warning_wrap"
                                                  @click="handleClickShowGoodsDiff('num',row)">
                                                <i class="iconfont icon-shuoming"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="row.hasOwnProperty('_child')&&row._child.length" class="goods_spec_wrap">
                                <ul class="goods_spec_list">
                                    <template v-if="row.is_expand">
                                        <li v-for="child in row._child"
                                            :key="child.part_id"
                                            class="good_part_item"
                                            v-text="`${child.part_name}：${child.goods_sku_name}*${child.num}`">
                                        </li>
                                    </template>
                                    <template v-else>
                                        <li v-for="child in row._child.slice(0,1)"
                                            :key="child.part_id"
                                            class="good_part_item"
                                            v-text="`${child.part_name}：${child.goods_sku_name}*${child.num}`">
                                        </li>
                                    </template>
                                </ul>
                                <div class="handle_expand_btn" @click="handleClickExpandConfig(row)">
                                        <span class="handle_expand_text"
                                              v-text="row.is_expand?'收起配置':'展开配置'"></span>
                                    <i :class="row.is_expand?'icon-shangjiantou':'icon-xiajiantou'"
                                       class="iconfont"></i>
                                </div>
                            </div>
                            <div class="goods_amount_wrap">
                                <div class="cost_guide_price_wrap flex_wrap">
                                    <img alt=""
                                         src="https://download.hecoos.com/enlightv/2025-10/d83f6be23fa8ac527f87c9296c8e1e39.svg">
                                    <span :class="{'del_text':row.action==='del'}"
                                          v-text="row.order_return_goods_id?'--':'¥' + row.cost_price"></span>
                                    <img alt=""
                                         src="https://download.hecoos.com/enlightv/2025-10/4283680c308ffa0dee2c8105fda1ed53.svg">
                                    <span :class="{'del_text':row.action==='del'}"
                                          v-text="row.order_return_goods_id?'--':'¥' + row.guide_price"></span>
                                </div>
                                <div>
                                    <div class="flex_wrap">
                                        <span>总价：</span>
                                        <span :class="{'del_text':row.action==='del'}"
                                              class="subtotal_price"
                                              v-text="'¥' + row.subtotal_price.text"></span>
                                        <span v-if="row.diff_total_price&&row.diff_total_price.is_diff"
                                              class="handle_icon_wrap handle_icon_warning_wrap"
                                              @click="handleClickShowGoodsDiff('subtotal_price',row)">
                                            <i class="iconfont icon-shuoming"></i>
                                        </span>
                                    </div>
                                    <div v-if="row.guide_price&&row.price.value&&Number(row.guide_price)!==row.price.value"
                                         :class="{'del_text':row.action==='del'}"
                                         class="ta_r">
                                        <div :class="'discounts_'+goodsDiscountsTextOrClass(row,'class',)"
                                             class="discounts_text"
                                             v-text="goodsDiscountsTextOrClass(row,'text')"></div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </el-form-item>
                <el-form-item v-else-if="item.field_type==='money_compute_mode'">
                    <div class="order_total_amount_wrap">
                        <div>
                            <span>订单总金额：</span>
                            <span v-text="item.field_value.new&&item.field_value.new.text?'¥'+item.field_value.new.text:'--'"></span>
                        </div>
                        <el-tooltip v-if="item.field_value&&item.field_value.old" effect="dark" placement="top">
                            <div slot="content">
                                <span>修改前：</span>
                                <span v-text="item.field_value&&item.field_value.old.text?'¥'+item.field_value.old.text:'--'"></span>
                            </div>
                            <span class="handle_icon_wrap handle_icon_warning_wrap">
                                <i class="iconfont icon-shuoming"></i>
                            </span>
                        </el-tooltip>
                    </div>
                </el-form-item>
                <el-form-item v-else-if="item.field_type==='order_amount_compute_mode'" :label="item.field_name">
                    <div v-if="item.num_display_style==='1'" class="flex_wrap">
                        <div v-if="item.field_value.old&&item.field_value.old.text" class="value_text"
                             v-text="item.field_value.old.text"></div>
                        <i class="iconfont icon-youjiantou"></i>
                        <div v-if="item.field_value.new&&item.field_value.new.text" class="value_text"
                             v-text="item.field_value.new.text"></div>
                    </div>
                    <div v-else class="flex_wrap">
                        <div v-if="item.field_value.old&&item.field_value.old.text" class="value_text"
                             v-text="item.field_value.old.text+'%'"></div>
                        <i class="iconfont icon-youjiantou"></i>
                        <div v-if="item.field_value.new&&item.field_value.new.text" class="value_text"
                             v-text="item.field_value.new.text+'%'"></div>
                    </div>
                </el-form-item>
                <el-form-item v-else-if="item.field_type==='customer_contact'" :label="item.field_name">
                    <div class="flex_wrap">
                        <div v-if="item.field_value.old&&item.field_value.old.text&&item.field_value.old.text.length">
                                <span v-for="value in item.field_value.old.text"
                                      :key="value.id"
                                      class="value_text" v-text="value.name"></span>
                        </div>
                        <i class="iconfont icon-youjiantou"></i>
                        <div v-if="item.field_value.new&&item.field_value.new.text&&item.field_value.new.text.length">
                                <span v-for="value in item.field_value.new.text" :key="value.id"
                                      class="value_text" v-text="value.name"></span>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item v-else-if="item.field_type==='radio_project'" :label="item.field_name">
                    <div class="flex_wrap">
                        <div v-if="item.field_value.old&&item.field_value.old.value" class="value_text"
                             v-text="item.field_value.old.text"></div>
                        <i class="iconfont icon-youjiantou"></i>
                        <div v-if="item.field_value.new&&item.field_value.new.value" class="value_text"
                             v-text="item.field_value.new.text"></div>
                    </div>
                </el-form-item>
                <el-form-item v-else-if="item.field_type==='radio_customer'" :label="item.field_name">
                    <div class="flex_wrap">
                        <div v-if="item.field_value.old&&item.field_value.old.value" class="value_text"
                             v-text="item.field_value.old.text"></div>
                        <i class="iconfont icon-youjiantou"></i>
                        <div v-if="item.field_value.new&&item.field_value.new.value" class="value_text"
                             v-text="item.field_value.new.text"></div>
                    </div>
                </el-form-item>
                <el-form-item v-else-if="item.field_type==='money'||item.field_type==='radio'"
                              :label="item.field_name">
                    <div class="flex_wrap">
                        <div class="value_text"
                             v-text="item.field_value.old&&item.field_value.old.text?item.field_value.old.text:'--'"></div>
                        <i class="iconfont icon-youjiantou"></i>
                        <div class="value_text"
                             v-text="item.field_value.new&&item.field_value.new.text?item.field_value.new.text:'--'"></div>
                    </div>
                </el-form-item>
                <el-form-item v-else-if="item.field_type==='checkbox'" :label="item.field_name">
                    <div class="flex_wrap">
                        <div class="value_text"
                             v-text="item.field_value.old&&item.field_value.old.text?item.field_value.old.text.join():'--'"></div>
                        <i class="iconfont icon-youjiantou"></i>
                        <div class="value_text"
                             v-text="item.field_value.new&&item.field_value.new.text?item.field_value.new.text.join():'--'"></div>
                    </div>
                </el-form-item>
                <el-form-item v-else-if="item.field_type==='contact'" :label="item.field_name">
                    <div class="flex_wrap">
                        <div class="value_text">
                            <div v-if="item.field_value.old&&item.field_value.old.text"></div>
                            <div v-else>--</div>
                        </div>
                        <i class="iconfont icon-youjiantou"></i>
                        <div class="value_text">
                            <div v-if="item.field_value.new&&item.field_value.new.text&&item.field_value.new.text.length">
                                <span v-for="contact in item.field_value.new.text" v-text="contact.name"></span>
                            </div>
                            <div v-else>--</div>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item v-else-if="item.field_type==='file'" :label="item.field_name">
                    <div>
                        <div v-if="item.field_value.old&&item.field_value.old.length"
                             class="m_file_outer_wrap">
                            <ul class="m_upload_file_list">
                                <li v-for="file in item.field_value.new" class="upload_file_item">
                                    <div class="file_left_wrap">
                                        <div class="file_info_wrap">
                                            <p class="file_name" v-text="file.file_name"></p>
                                        </div>
                                    </div>
                                    <div class="file_right_wrap">
                                        <el-tooltip content="预览"
                                                    effect="dark"
                                                    placement="top">
                                            <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                                <i class="iconfont icon-yanjing"></i>
                                            </span>
                                        </el-tooltip>
                                        <span class="line"></span>
                                        <el-tooltip content="下载"
                                                    effect="dark"
                                                    placement="top">
                                                <span class="handle_icon_wrap"
                                                      @click="handleClickDownloadFile(file)">
                                                    <i class="iconfont icon-daochu"></i>
                                                </span>
                                        </el-tooltip>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div v-else>--</div>
                    </div>
                    <i class="iconfont icon-xiajiang"></i>
                    <div>
                        <div v-if="item.field_value.new&&item.field_value.new.length" class="m_file_outer_wrap">
                            <ul class="m_upload_file_list">
                                <li v-for="file in item.field_value.new" class="upload_file_item">
                                    <div class="file_left_wrap">
                                        <div class="file_info_wrap">
                                            <p class="file_name" v-text="file.file_name"></p>
                                        </div>
                                    </div>
                                    <div class="file_right_wrap">
                                        <el-tooltip content="预览"
                                                    effect="dark"
                                                    placement="top">
                                            <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                                <i class="iconfont icon-yanjing"></i>
                                            </span>
                                        </el-tooltip>
                                        <span class="line"></span>
                                        <el-tooltip content="下载"
                                                    effect="dark"
                                                    placement="top">
                                                <span class="handle_icon_wrap"
                                                      @click="handleClickDownloadFile(file)">
                                                    <i class="iconfont icon-daochu"></i>
                                                </span>
                                        </el-tooltip>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div v-else>--</div>
                    </div>
                </el-form-item>
                <el-form-item v-else-if="item.field_type==='image'" :label="item.field_name">
                    <div>
                        <div v-if="item.field_value.old&&item.field_value.old.length" class="image_outer_wrap">
                            <ul class="upload_image_list">
                                <li v-for="image in item.field_value.old"
                                    :key="image.file_path"
                                    class="upload_image_item">
                                    <el-image :preview-src-list="item.field_value.old.map(img=>img.file_path)"
                                              :src="image.file_path"
                                              fit="cover">
                                    </el-image>
                                </li>
                            </ul>
                        </div>
                        <div v-else>--</div>
                    </div>
                    <i class="iconfont icon-xiajiang"></i>
                    <div>
                        <div v-if="item.field_value.new&&item.field_value.new.length" class="image_outer_wrap">
                            <ul class="upload_image_list">
                                <li v-for="image in item.field_value.new"
                                    :key="image.file_path"
                                    class="upload_image_item">
                                    <el-image :preview-src-list="item.field_value.new.map(img=>img.file_path)"
                                              :src="image.file_path"
                                              fit="cover">
                                    </el-image>
                                </li>
                            </ul>
                        </div>
                        <div v-else>--</div>
                    </div>
                </el-form-item>
                <el-form-item v-else :label="item.field_name">
                    <div class="flex_wrap">
                        <div class="value_text"
                             v-text="item.field_value.old&&item.field_value.old.value?item.field_value.old.value:'--'"></div>
                        <i class="iconfont icon-youjiantou"></i>
                        <div class="value_text"
                             v-text="item.field_value.new&&item.field_value.new.value?item.field_value.new.value:'--'"></div>
                    </div>
                </el-form-item>
            </template>
            <div v-if="Object.keys(business_data).length">
                <h3 class="approve_title_h3">修改原因</h3>
                <el-form-item>
                    <div v-text="business_data.remarks"></div>
                </el-form-item>
            </div>
        </template>
        <!--订单售后退货详情-->
        <template v-else-if="after_sales_type === 'order_return'">
            <div v-if="Object.keys(business_data).length">
                <el-form-item label="开户名">
                    <span v-text="form_detail.refund_account_name"></span>
                </el-form-item>
                <el-form-item label="开户账号">
                    <span v-text="form_detail.refund_card_number"></span>
                </el-form-item>
                <el-form-item label="开户行">
                    <span v-text="form_detail.refund_bank_name"></span>
                </el-form-item>
                <el-form-item label="退货原因">
                    <span v-text="form_detail.remarks"></span>
                </el-form-item>
            </div>
            <h3 class="approve_title_h3">退货产品</h3>
            <div class="mb_16">
                <ul class="m_order_goods_list">
                    <li v-for="(row,index) in form_detail.return_goods" class="m_order_goods_item">
                        <div class="flex_wrap table_goods_info_wrap">
                            <div v-if="row.deliver_status!==0&&row.is_virtual===1" class="ship_status">
                                <img v-if="row.deliver_status == 1"
                                     alt=""
                                     src="https://download.hecoos.com/enlightv/2024-27/424WFeARXDkJEsSZHDjt.svg">
                                <img v-else-if="row.deliver_status == 2"
                                     alt=""
                                     src="https://download.hecoos.com/enlightv/2024-27/QxeNcB2BsHmwpsXPKhkM.svg">
                                <img v-else-if="row.deliver_status == 3"
                                     alt=""
                                     src="https://download.hecoos.com/enlightv/2024-27/iBpD5aYdCjNW2ywzH2HK.svg">
                            </div>
                            <img :src="row.goods_image?row.goods_image:'https://download.hecoos.com/enlightv/2025-03/9d94ed737997e3e1e393bb74609ffc64.jpg'"
                                 alt=""
                                 class="goods_image">
                            <div style="flex: 1">
                                <div class="goods_name_wrap">
                                    <div class="goods_name">
                                        <span v-text="row.goods_name"></span>
                                        <span v-if="row.goods_sku_name&&row.goods_type!=='bundle'"
                                              v-text="'：'+row.goods_sku_name"></span>
                                    </div>
                                    <el-tag :type="row.type===1?'success':'warning'" size="mini">
                                        {{ row.type === 1 ? '销售' : '租借' }}
                                    </el-tag>
                                </div>
                                <div class="flex_js_wrap">
                                    <div>
                                        <span class="goods_amount_label">总价：</span>
                                        <span class="goods_price" v-text="'¥'+row.refund_subtotal_price"></span>
                                    </div>
                                    <span v-text="'X' + row.return_num"></span>
                                </div>
                            </div>
                        </div>
                        <div v-if="row.hasOwnProperty('_child')&&row._child.length" class="goods_spec_wrap">
                            <ul class="goods_spec_list">
                                <template v-if="row.is_expand">
                                    <li v-for="child in row._child"
                                        :key="child.part_id"
                                        class="good_part_item"
                                        v-text="`${child.part_name}：${child.goods_sku_name}*${child.num}`">
                                    </li>
                                </template>
                                <template v-else>
                                    <li v-for="child in row._child.slice(0,1)"
                                        :key="child.part_id"
                                        class="good_part_item"
                                        v-text="`${child.part_name}：${child.goods_sku_name}*${child.num}`">
                                    </li>
                                </template>
                            </ul>
                            <div class="handle_expand_btn" @click="handleClickExpandConfig(row)">
                                        <span class="handle_expand_text"
                                              v-text="row.is_expand?'收起配置':'展开配置'"></span>
                                <i :class="row.is_expand?'icon-shangjiantou':'icon-xiajiantou'"
                                   class="iconfont"></i>
                            </div>
                        </div>
                    </li>
                </ul>
                <div class="order_total_amount_wrap">
                    <span>应退款总计：</span>
                    <span v-text="'¥'+form_detail.refund_amount"></span>
                </div>
            </div>
            <div v-if="Object.keys(business_data).length===0">
                <el-form-item label="开户名">
                    <span v-text="form_detail.refund_account_name"></span>
                </el-form-item>
                <el-form-item label="开户账号">
                    <span v-text="form_detail.refund_card_number"></span>
                </el-form-item>
                <el-form-item label="开户行">
                    <span v-text="form_detail.refund_bank_name"></span>
                </el-form-item>
                <el-form-item label="退货原因">
                    <span v-text="form_detail.remarks"></span>
                </el-form-item>
            </div>
            <h3 class="approve_title_h3">退货产品金额</h3>
            <el-form-item label="订单总金额：">
                <div class="flex_wrap">
                    <span v-text="Number(form_detail.total_price).toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2})"></span>
                    <i class="iconfont icon-youjiantou"></i>
                    <span v-text="(Number(form_detail.total_price)-Number(form_detail.refund_amount)).toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2})"></span>
                </div>
            </el-form-item>
            <el-form-item label="已回款金额：">
                <span v-text="Number(form_detail.repay_price).toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2})"></span>
            </el-form-item>
            <el-form-item label="退货产品金额：">
                <span v-text="Number(form_detail.refundable_amount).toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2})"></span>
            </el-form-item>
            <el-form-item label="实际退款金额：">
                <span v-text="Number(form_detail.real_refund_amount).toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2})"></span>
            </el-form-item>
        </template>
        <!--订单售后退款详情-->
        <template v-else-if="after_sales_type === 'order_refund'">
            <el-form-item label="退款类型">
                <span v-text="form_detail.refund_type==='ordinary'?'普通退款':form_detail.refund_type==='rent'?'租金退款':'押金退款'"></span>
            </el-form-item>
            <el-form-item label="订单金额">
                <span v-text="'¥'+form_detail.order_total_price"></span>
            </el-form-item>
            <el-form-item label="订单实际回款金额">
                <span v-text="'¥'+form_detail.order_repay_price"></span>
                <span v-text="`（${(Number(form_detail.order_repay_price)/Number(form_detail.order_total_price) *10000 /100).toFixed(2)}%）`"></span>
            </el-form-item>
            <el-form-item v-if="form_detail.apply_type===1">
                <h3 class="approve_title_h3">退款关联明细</h3>
                <ul class="relate_repay_list">
                    <li class="relate_repay_item"
                        v-for="row in form_detail.relate_repay">
                        <div class="relate_repay_item_header">
                            <div v-text="row.receivable_no" class="receivable_no"></div>
                            <div class="payment_date" v-text="row.payment_date"></div>
                        </div>
                        <div class="relate_repay_item_content">
                            <div class="flex_wrap">
                                <span class="field_label">回款金额：</span>
                                <span class="field_value"
                                      v-text="'¥' +Number(row.payment_amount).toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2})"></span>
                            </div>
                            <div class="flex_wrap">
                                <span class="field_label">回款方式：</span>
                                <span class="field_value" v-text="row.payment_method_name"></span>
                            </div>
                        </div>
                    </li>
                </ul>
<!--                <vxe-table :data="form_detail.relate_repay" border>
                    <vxe-column field="receivable_no" title="回款编号"></vxe-column>
                    <vxe-column field="payment_date" title="回款日期"></vxe-column>
                    <vxe-column align="right" field="" title="回款金额">
                        <template #default="{row}">
                            <span v-text="'¥'+row.payment_amount"></span>
                        </template>
                    </vxe-column>
                    <vxe-column field="payment_method_name" title="回款方式"></vxe-column>
                </vxe-table>-->
            </el-form-item>
            <el-form-item label="">
                <div class="order_total_amount_wrap flex_js_wrap">
                    <span>退款金额</span>
                    <span v-text="'¥'+Number(form_detail.refund_amount).toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2})"></span>
                </div>
            </el-form-item>
            <el-form-item label="退款日期">
                <span v-text="form_detail.refund_date"></span>
            </el-form-item>
            <el-form-item label="退款原因">
                <span v-text="form_detail.remarks"></span>
            </el-form-item>
            <el-form-item label="开户名">
                <span v-text="form_detail.refund_account_name"></span>
            </el-form-item>
            <el-form-item label="开户账号">
                <span v-text="form_detail.refund_card_number"></span>
            </el-form-item>
            <el-form-item label="开户行">
                <span v-text="form_detail.refund_bank_name"></span>
            </el-form-item>
        </template>
        <!--订单售后换货详情-->
        <template v-else-if="after_sales_type === 'order_exchange'">
            <el-form-item>
                <h3 class="approve_title_h3">换新产品</h3>
                <ul class="m_order_goods_list">
                    <li v-for="(row,index) in form_detail.exchange_goods" class="m_order_goods_item">
                        <div class="flex_wrap table_goods_info_wrap">
                            <img :src="row.goods_image?row.goods_image:'https://download.hecoos.com/enlightv/2025-03/9d94ed737997e3e1e393bb74609ffc64.jpg'"
                                 alt=""
                                 class="goods_image">
                            <div style="flex: 1">
                                <div class="goods_name_wrap">
                                    <span v-text="row.goods_name"></span>
                                    <span v-if="row.goods_sku_name&&row.goods_type!=='bundle'"
                                          v-text="'：'+row.goods_sku_name"></span>
                                    <el-tag :type="row.type===1?'success':'warning'" size="mini">
                                        {{ row.type === 1 ? '销售' : '租借' }}
                                    </el-tag>
                                </div>
                            </div>
                        </div>
                        <div v-if="row.hasOwnProperty('_child')&&row._child.length" class="goods_spec_wrap">
                            <ul class="goods_spec_list">
                                <template v-if="row.is_expand">
                                    <li v-for="child in row._child"
                                        :key="child.part_id"
                                        class="good_part_item"
                                        v-text="`${child.part_name}：${child.goods_sku_name}*${child.num}`">
                                    </li>
                                </template>
                                <template v-else>
                                    <li v-for="child in row._child.slice(0,1)"
                                        :key="child.part_id"
                                        class="good_part_item"
                                        v-text="`${child.part_name}：${child.goods_sku_name}*${child.num}`">
                                    </li>
                                </template>
                            </ul>
                            <div class="handle_expand_btn" @click="handleClickExpandConfig(row)">
                                    <span class="handle_expand_text"
                                          v-text="row.is_expand?'收起配置':'展开配置'"></span>
                                <i :class="row.is_expand?'icon-shangjiantou':'icon-xiajiantou'"
                                   class="iconfont"></i>
                            </div>
                        </div>
                        <div class="exchange_goods_wrap">
                            <div class="exchange_goods_label">换新产品：</div>
                            <ul v-if="row.goods_type==='bundle'" class="exchange_goods_list">
                                <li v-for="child in row._child" class="exchange_goods_item">
                                    <span v-text="child.part_name + '：' +child.goods_sku_name"></span>
                                    <span v-text="'*' + child.exchange_num"></span>
                                </li>
                            </ul>
                            <div v-else class="exchange_goods_item">
                                <span v-text="row.goods_name"></span>
                                <span v-text="'*'+row.exchange_num"></span>
                            </div>
                        </div>
                    </li>
                </ul>
            </el-form-item>
            <el-form-item label="换新原因">
                <span v-text="form_detail.remarks"></span>
            </el-form-item>
        </template>
        <!--订单售后归还详情-->
        <template v-else-if="after_sales_type === 'order_equipment_return'">
            <el-form-item>
                <h3 class="approve_title_h3">归还产品</h3>
                <ul class="m_order_goods_list">
                    <li v-for="(row,index) in form_detail.equipment_return_goods" class="m_order_goods_item">
                        <div class="flex_wrap table_goods_info_wrap">
                            <img :src="row.goods_image?row.goods_image:'https://download.hecoos.com/enlightv/2025-03/9d94ed737997e3e1e393bb74609ffc64.jpg'"
                                 alt=""
                                 class="goods_image">
                            <div style="flex: 1">
                                <div class="goods_name_wrap">
                                    <span v-text="row.goods_name"></span>
                                    <span v-if="row.goods_sku_name&&row.goods_type!=='bundle'"
                                          v-text="'：'+row.goods_sku_name"></span>
                                    <el-tag :type="row.type===1?'success':'warning'" size="mini">
                                        {{ row.type === 1 ? '销售' : '租借' }}
                                    </el-tag>
                                </div>
                            </div>
                        </div>
                        <div v-if="row.hasOwnProperty('_child')&&row._child.length" class="goods_spec_wrap">
                            <ul class="goods_spec_list">
                                <template v-if="row.is_expand">
                                    <li v-for="child in row._child"
                                        :key="child.part_id"
                                        class="good_part_item"
                                        v-text="`${child.part_name}：${child.goods_sku_name}*${child.num}`">
                                    </li>
                                </template>
                                <template v-else>
                                    <li v-for="child in row._child.slice(0,1)"
                                        :key="child.part_id"
                                        class="good_part_item"
                                        v-text="`${child.part_name}：${child.goods_sku_name}*${child.num}`">
                                    </li>
                                </template>
                            </ul>
                            <div class="handle_expand_btn" @click="handleClickExpandConfig(row)">
                                    <span class="handle_expand_text"
                                          v-text="row.is_expand?'收起配置':'展开配置'"></span>
                                <i :class="row.is_expand?'icon-shangjiantou':'icon-xiajiantou'"
                                   class="iconfont"></i>
                            </div>
                        </div>
                        <div class="exchange_goods_wrap">
                            <div class="exchange_goods_label" style="min-width: 100px">本次归还数量：</div>
                            <ul v-if="row.goods_type==='bundle'" class="exchange_goods_list">
                                <li v-for="child in row._child.filter(child=>child.equipment_return_num>0)" class="exchange_goods_item">
                                    <span v-text="child.goods_sku_name"></span>
                                    <span v-text="'*' + child.equipment_return_num"></span>
                                </li>
                            </ul>
                            <div v-else class="exchange_goods_item">
                                <span v-text="row.goods_name"></span>
                                <span v-text="'*'+row.equipment_return_num"></span>
                            </div>
                        </div>
                    </li>
                </ul>
            </el-form-item>
        </template>
        <!--订单售后续租详情-->
        <template v-else-if="after_sales_type === 'order_renewal'">
            <el-form-item v-if="Object.keys(business_data).length" label="续租说明">
                <div v-text="form_detail.remarks"></div>
            </el-form-item>
            <el-form-item>
                <h3 class="approve_title_h3">续租变更明细</h3>
                <ul class="m_order_goods_list">
                    <li v-for="(row,index) in form_detail.renewal_goods" class="m_order_goods_item">
                        <div class="flex_wrap table_goods_info_wrap">
                            <img :src="row.goods_image?row.goods_image:'https://download.hecoos.com/enlightv/2025-03/9d94ed737997e3e1e393bb74609ffc64.jpg'"
                                 alt=""
                                 class="goods_image">
                            <div style="flex: 1">
                                <div class="goods_name_wrap">
                                    <span v-text="row.goods_name"></span>
                                    <span v-if="row.goods_sku_name&&row.goods_type!=='bundle'"
                                          v-text="'：'+row.goods_sku_name"></span>
                                    <el-tag :type="row.type===1?'success':'warning'" size="mini">
                                        {{ row.type === 1 ? '销售' : '租借' }}
                                    </el-tag>
                                </div>
                            </div>
                        </div>
                        <div v-if="row.hasOwnProperty('_child')&&row._child.length" class="goods_spec_wrap">
                            <ul class="goods_spec_list">
                                <template v-if="row.is_expand">
                                    <li v-for="child in row._child"
                                        :key="child.part_id"
                                        class="good_part_item"
                                        v-text="`${child.part_name}：${child.goods_sku_name}*${child.num}`">
                                    </li>
                                </template>
                                <template v-else>
                                    <li v-for="child in row._child.slice(0,1)"
                                        :key="child.part_id"
                                        class="good_part_item"
                                        v-text="`${child.part_name}：${child.goods_sku_name}*${child.num}`">
                                    </li>
                                </template>
                            </ul>
                            <div class="handle_expand_btn" @click="handleClickExpandConfig(row)">
                                    <span class="handle_expand_text"
                                          v-text="row.is_expand?'收起配置':'展开配置'"></span>
                                <i :class="row.is_expand?'icon-shangjiantou':'icon-xiajiantou'"
                                   class="iconfont"></i>
                            </div>
                        </div>
                        <van-field label="续租时间变更：" readonly label-width="7em">
                            <template #input>
                                <div class="flex_wrap">
                                    <span v-text="row.end_at"></span>
                                    <i class="iconfont icon-youjiantou"></i>
                                    <span v-text="row.renewal_date"></span>
                                </div>
                            </template>
                        </van-field>
                    </li>
                </ul>
            </el-form-item>
            <el-form-item v-if="!Object.keys(business_data).length" label="续租说明">
                <div v-text="form_detail.remarks"></div>
            </el-form-item>
        </template>
        <!--订单售后续租详情-->
        <template v-else-if="after_sales_type === 'order_rental_to_sale'">
            <div class="approve_title_h3">转销售明细</div>
            <ul class="m_order_goods_list">
                <li v-for="(row,index) in form_detail.rental_to_sale_goods"
                    class="m_order_goods_item">
                    <div class="flex_wrap table_goods_info_wrap">
                        <div v-if="row.deliver_status!==0&&row.is_virtual===1" class="ship_status">
                            <img v-if="row.deliver_status == 1"
                                 alt=""
                                 src="https://download.hecoos.com/enlightv/2024-27/424WFeARXDkJEsSZHDjt.svg">
                            <img v-else-if="row.deliver_status == 2"
                                 alt=""
                                 src="https://download.hecoos.com/enlightv/2024-27/QxeNcB2BsHmwpsXPKhkM.svg">
                            <img v-else-if="row.deliver_status == 3"
                                 alt=""
                                 src="https://download.hecoos.com/enlightv/2024-27/iBpD5aYdCjNW2ywzH2HK.svg">
                        </div>
                        <img :src="row.goods_image?row.goods_image:'https://download.hecoos.com/enlightv/2025-03/9d94ed737997e3e1e393bb74609ffc64.jpg'"
                             alt=""
                             class="goods_image">
                        <div style="flex: 1">
                            <div class="goods_name_wrap">
                                <span v-text="row.goods_name"></span>
                                <span v-if="row.goods_sku_name&&row.goods_type!=='bundle'"
                                      v-text="'：'+row.goods_sku_name"></span>
                            </div>
                            <div class="flex_js_wrap">
                                <div>
                                    <span class="goods_price" v-text="'¥'+row.sale_price"></span>
                                </div>
                                <span v-text="'X' + row.sale_num"></span>
                            </div>
                        </div>
                    </div>
                    <div v-if="row.hasOwnProperty('_child')&&row._child.length" class="goods_spec_wrap">
                        <ul class="goods_spec_list">
                            <template v-if="row.is_expand">
                                <li v-for="child in row._child"
                                    :key="child.part_id"
                                    class="good_part_item"
                                    v-text="`${child.part_name}：${child.goods_sku_name}*${child.num}`">
                                </li>
                            </template>
                            <template v-else>
                                <li v-for="child in row._child.slice(0,1)"
                                    :key="child.part_id"
                                    class="good_part_item"
                                    v-text="`${child.part_name}：${child.goods_sku_name}*${child.num}`">
                                </li>
                            </template>
                        </ul>
                        <div class="handle_expand_btn" @click="handleClickExpandConfig(row)">
                                    <span class="handle_expand_text"
                                          v-text="row.is_expand?'收起配置':'展开配置'"></span>
                            <i :class="row.is_expand?'icon-shangjiantou':'icon-xiajiantou'"
                               class="iconfont"></i>
                        </div>
                    </div>
                    <van-field label="销售总价"
                               readonly
                               input-align="right"
                               :value="'¥'+row.sale_subtotal_price">
                    </van-field>
                </li>
            </ul>
            <div class="order_total_amount_wrap">
                <div v-if="form_detail.rental_to_sale_goods.length">
                    <span>总计：</span>
                    <span v-text="saleSubtotalPrice"></span>
                </div>
            </div>
            <div v-if="form_detail.custom_amount_change.length" class="mt_16">
                <div class="approve_title_h3">订单金额变化</div>
                <ul class="custom_amount_change_list">
                    <li class="custom_amount_change_item">
                        <div class="custom_amount_field_name">订单总金额</div>
                        <div class="flex_wrap">
                            <span v-text="form_detail.total_price?Number(form_detail.total_price).toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2}) : '--'"></span>
                            <i class="iconfont icon-youjiantou"></i>
                            <span v-text="form_detail.original_total_price?Number(form_detail.original_total_price).toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2}) : '--'"></span>
                        </div>
                    </li>
                    <li v-for="item in form_detail.custom_amount_change"
                        :key="item.field_key" class="custom_amount_change_item">
                        <div class="custom_amount_field_name" v-text="item.field_name"></div>
                        <div class="flex_wrap">
                            <span v-text="item.old_value && item.old_value.text ? item.old_value.text : '--'"></span>
                            <i class="iconfont icon-youjiantou"></i>
                            <span v-text="item.new_value && item.new_value.text ? item.new_value.text : '--'"></span>
                        </div>
                    </li>
                </ul>
            </div>
        </template>
        <van-dialog v-model="orderGoodsDIffShow"
                    confirm-button-color="#2990FF"
                    show-cancel-button
                    title="修改前后变化">
            <div class="order_goods_diff_text">
                <span class="field_name" v-text="orderGoodsFieldName+'：'"></span>
                <span v-text="orderGoodsDIffOldText"></span>
                <i class="iconfont icon-youjiantou"></i>
                <span v-text="orderGoodsDIffNewText"></span>
            </div>
        </van-dialog>
    </el-form>
</template>
<script>
import PersonnelCard from "@/components/pComponents/PersonnelCard";
import {goodsPriceDiscountsText} from "@/utils";

export default {
    name: "afterSaleApproveDetail",
    data() {
        return {
            orderGoodsDIffShow: false,
            orderGoodsFieldName: '',
            orderGoodsDIffOldText: '',
            orderGoodsDIffNewText: '',
        }
    },
    props: {
        after_sales_type: {
            type: String,
            default: ''
        },
        form_detail: {
            type: [Object, Array],
            required: true,
        },
        business_data: {
            type: Object,
            default: () => {
                return {};
            },
        },//审批内容
        label_position: {
            type: String,
            default: 'top'
        },//审批内容
    },
    components: {PersonnelCard},
    computed: {
        afterSaleTypeName() {
            switch (this.after_sales_type) {
                case 'order_edit':
                    return '售后-订单编辑'
                case 'order_return':
                    return '售后-退货'
                case 'order_refund':
                    return '售后-退款'
                case 'order_exchange':
                    return '售后-损坏换新'
                case 'order_equipment_return':
                    return '售后-归还'
                case 'order_renewal':
                    return '售后-续租'
                case 'order_rental_to_sale':
                    return '租借转销售'
            }
        },
        saleSubtotalPrice() {
            return this.form_detail.rental_to_sale_goods.reduce((acc, cur) => acc + Number(cur.sale_subtotal_price), 0).toFixed(2)
        },
    },
    created() {
    },
    mounted() {
    },
    methods: {
        //点击打开组合产品的配置
        handleClickExpandConfig(row) {
            if (row.hasOwnProperty('is_expand')) {
                row.is_expand = !row.is_expand
            } else {
                this.$set(row, 'is_expand', true)
            }
        },

        //点击订单详情
        handleClickOrderDetail() {
            this.$router.push({
                name: "OrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    order_id: this.business_data.order.id,
                    name: this.business_data.order.order_num,
                },
            });
        },

        //点击客户详情
        handleClickCustomerDetail() {
            this.$router.push({
                name: "CustomerPrivateSeasDetail",
                params: {
                    isPush: true,
                },
                query: {
                    customer_id: this.business_data.customer.id,
                    name: this.business_data.customer.name,
                },
            });
        },

        //附件预览事件
        handleClickPreview(file) {
            if (file.file_type.includes('image')) {
                this.previewImgList = [file.file_path]
                this.previewImgSrc = file.file_path
                this.$refs.preview_img.showViewer = true
            } else {
                if (file.file_type.includes('pdf')) {
                    window.open(file.file_path)
                } else {
                    this.$message.error('当前文件格式不支持预览，请下载后查看')
                }
            }
        },

        //附件下载
        handleClickDownloadFile(file) {
            getOSSData(file.file_path, file.file_name);
        },

        // 商品优惠信息
        goodsDiscountsTextOrClass(row, key) {
            return goodsPriceDiscountsText(row)[key]
        },

        //订单商品变化
        handleClickShowGoodsDiff(field_key, row) {
            let field_name = ''
            let old_value = ''
            let new_value = ''
            switch (field_key) {
                case 'lease_time':
                    field_name = '租借时间'
                    old_value = `${row.diff_start_at && row.diff_start_at.is_diff ? row.diff_start_at.old : row.start_at} ~ ${row.diff_end_at && row.diff_end_at.is_diff ? row.diff_end_at.old : row.end_at}`
                    new_value = `${row.diff_start_at && row.diff_start_at.is_diff ? row.diff_start_at.new : row.start_at} ~ ${row.diff_end_at && row.diff_end_at.is_diff ? row.diff_end_at.new : row.end_at}`
                    break
                case 'num':
                    field_name = '数量'
                    old_value = row.diff_num.old ? row.diff_num.old : '--'
                    new_value = row.num
                    break
                case 'price':
                    field_name = '单价'
                    old_value = row.diff_price.old ? '¥' + row.diff_price.old.text : '--'
                    new_value = row.price && row.price.text ? '¥' + row.price.text : '--'
                    break
                case 'subtotal_price':
                    field_name = '总价'
                    old_value = row.diff_total_price.old ? '¥' + row.diff_total_price.old.text : '--'
                    new_value = row.subtotal_price ? '¥' + row.subtotal_price.text : '--'
                    break
            }
            this.orderGoodsDIffShow = true
            this.orderGoodsFieldName = field_name
            this.orderGoodsDIffOldText = old_value
            this.orderGoodsDIffNewText = new_value
        },
    },
}
</script>
<style lang="scss" scoped>
.approve_title_h3 {
    line-height: 22px;
    font-size: 14px;
    color: #333333;
    margin-bottom: 12px;
    font-weight: bold;
}

.relate_repay_item{
    padding: 0;
}

.del_text {
    text-decoration: line-through;
}

.order_total_amount_wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4px;
    border-radius: 0 0 6px 6px;
    background: #EDF0F4;
    padding: 8px 12px;
    color: #333333;
    font-weight: bold;
    line-height: 22px;
}

.icon-youjiantou {
    font-size: 14px;
    margin: 0 4px;
    color: #E44144;
}

.icon-xiajiang {
    font-size: 14px;
    margin: 0 4px;
    color: #E44144;
}

.m_order_goods_item {
    padding: 12px 0 0;
    border-bottom: 1px solid #E8E8E8;
}

.order_goods_diff_text{
    padding: 16px;

    .field_name{
        color: #999999;
    }
}

.exchange_goods_wrap{
    border-bottom: 1px solid #E8E8E8;
}
</style>